import { getStoredTheme, type Theme } from "@serophin/browser";
import { Monitor, Moon, Sun } from "lucide-preact";
import { useState } from "preact/hooks";
import { changeTheme } from "../../platform/theme";
import { SettingsCard } from "./SettingsCard";
import { ThemeOptionButton } from "./ThemeOptionButton";

const OPTIONS = [
  { value: "system", icon: Monitor, title: "System", description: "Follow system preference" },
  { value: "light", icon: Sun, title: "Light", description: "Bright and clear" },
  { value: "dark", icon: Moon, title: "Dark", description: "Easy on the eyes" },
] as const;

export const AppearanceSettings = () => {
  const [theme, setTheme] = useState<Theme>(getStoredTheme);

  const choose = (next: Theme) => {
    setTheme(next);
    changeTheme(next);
  };

  return (
    <SettingsCard icon={Monitor} title="Appearance">
      <div class="space-y-3">
        {OPTIONS.map((option) => (
          <ThemeOptionButton
            key={option.value}
            icon={option.icon}
            title={option.title}
            description={option.description}
            isSelected={theme === option.value}
            onClick={() => choose(option.value)}
          />
        ))}
      </div>
    </SettingsCard>
  );
};
